import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AssessmentQuestionInterface } from 'app/assessment/models';
import { DynamicQuestionComponent } from 'app/assessment/questions/dynamic-question-content/dynamic-question.component';


@Component({
  selector: 'cz-discomfort-details',
  templateUrl: './discomfort-details.component.html',
  styleUrls: ['./discomfort-details.component.scss'],
})
export class DiscomfortDetailsComponent extends DynamicQuestionComponent implements OnInit {
  @Input() public readonly type: string;
  @Input() public readonly question: AssessmentQuestionInterface;
  @Input() public readonly form: FormGroup;
  @Input() public readonly index: number;

  constructor() {
    super();
  }

  public ngOnInit(): void {
  }

}
